import { flatten, groupBy, keys, map, mapValues, sumBy, uniq } from 'lodash';
import { action, computed, observable, set } from 'mobx';
import { addDuration, autostore, Duration, getTotalSeconds, HttpClient, humanizeString, IConfig } from 'Mri.Web.Common';

export class EmailsStore {
    public constructor(httpClient: HttpClient) {
        this.httpClient = httpClient;
    }

    @action
    public async sendDowntimeEmail(model: Mri.Web.Portal.Controllers.Emails.MassEmailModel) {
        await this.httpClient.post<Mri.Web.Portal.Controllers.Emails.MassEmailModel>(`/api/v1/emails/mass`, model);
    }

    private readonly httpClient: HttpClient;
}